import { gql } from '@apollo/client';

export const VENDOR_ORDER_DONATION_FIELDS = gql`
  fragment VendorOrderDonationFields on VendorOrderDonation {
    _id
    donationId
    orderedItems {
      _id
      itemId
      quantity
      donationItemId
      vendorValue
      item {
        ...ItemFields
      }
    }
  }
`;

export const GET_VENDOR_ORDER_DONATION = gql`
  query GetVendorOrderDonation($id: ID!) {
    getVendorOrderDonation(id: $id) {
      ...VendorOrderDonationFields

      donation {
        _id
        user {
          _id
          givenName
          familyName
          email
        }
      }
    }
  }
`;

export const CREATE_VENDOR_ORDER_DONATION = gql`
  mutation CreateVendorOrderDonation(
    $donationId: ID!
    $vendorOrderId: ID!
    $orderedItems: [VendorOrderItemInput]!
  ) {
    createVendorOrderDonation(
      donationId: $donationId
      vendorOrderId: $vendorOrderId
      orderedItems: $orderedItems
    ) {
      ...VendorOrderDonationFields
    }
  }
`;

// TODO: update??
